export const PENDING_STATUS_CODES = ['PE', 'IP', 'Pending', 'Pended', 'In Process', 'In Progress'];
export const DENIED_STATUS_CODES = ['DE', 'Denied'];
export const COMPLETE_STATUS_CODES = ['AP', 'Approved', 'CL', 'Closed', 'Open'];
export const APPROVED_STATUS_CODES = ['AP', 'Approved', 'Open'];
export const CLOSED_STATUS_CODES = ['CL', 'Closed'];
